export const somenteDigitos = documento => String(documento ?? '').replace(/\D/g, '');

export const validaCpfCnpj = documento => {
  if (!documento) return false;

  const valorLimpo = somenteDigitos(documento);

  if (valorLimpo.length === 11) {
    if (/^(\d)\1{10}$/.test(valorLimpo)) return false;

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) {
      soma += parseInt(valorLimpo.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(valorLimpo.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma += parseInt(valorLimpo.substring(i - 1, i)) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(valorLimpo.substring(10, 11))) return false;

    return true;
  }

  if (valorLimpo.length === 14) {
    if (/^(\d)\1{13}$/.test(valorLimpo)) return false;

    let tamanho = valorLimpo.length - 2;
    let numeros = valorLimpo.substring(0, tamanho);
    const digitosVerificadores = valorLimpo.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitosVerificadores.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = valorLimpo.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitosVerificadores.charAt(1))) return false;

    return true;
  }

  return false;
};
